<script setup lang="ts">
import { computed } from 'vue';
import config from '@/config/ConfigProvider';
import { useLocale } from '@/plugins/translation';
import { useRouter } from 'vue-router';

const logoImageFile = config.value('logoImageFile');
const serviceName = config.value('serviceName');

const { t, l } = useLocale();

const logoImage = computed(() => new URL(`/src/assets/images/${logoImageFile}`, import.meta.url).href);

const router = useRouter();
const onClick = () => {
  router.push('/');
};
</script>

<template>
  <v-container fluid flex class="text-center">
    <v-row class="row--fullsize mt-9" justify="center">
      <v-col xs="12" md="5" lg="3">
        <v-img :src="logoImage" max-height="60px" :alt="serviceName + ' logo'"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-secondary">
        <h1>{{ t(l.forbidden.title) }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-secondary">
        {{ t(l.forbidden.text) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn class="button-log-out-user" color="secondary" @click="onClick">{{ t(l.forbidden.button) }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss"></style>
